module.exports = __webpack_public_path__ + "static/media/1.bba1e5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/grodno/1.jpg
// module id = 223
// module chunks = 0